import * as tslib_1 from "tslib";
import * as React from 'react';
import BoardyDialog from './BoardyDialog';
import { RaisedButton, FlatButton, TextField } from 'material-ui';
var styles = {
    form: {
        padding: '1rem'
    },
    action: {
        marginRight: '1rem',
        color: 'white',
    }
};
var TaskTimeItemDialog = /** @class */ (function (_super) {
    tslib_1.__extends(TaskTimeItemDialog, _super);
    function TaskTimeItemDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            hours: '',
            note: ''
        };
        _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.submit();
        };
        _this.handleOkClikc = function (e) {
            e.preventDefault();
            _this.submit();
        };
        _this.submit = function () {
            _this.props.onSubmit(tslib_1.__assign({}, _this.state));
            _this.clear();
        };
        _this.clear = function () {
            _this.setState({ hours: '', note: '' });
        };
        _this.handleHourChange = function (e) {
            _this.setState({ hours: e.target.value });
        };
        _this.handleNoteChange = function (e) {
            _this.setState({ note: e.target.value });
        };
        _this.handleCancel = function () {
            _this.props.onCancel();
        };
        _this.state = {
            hours: props.initialHours + '',
            note: props.initialNotes + ''
        };
        return _this;
    }
    TaskTimeItemDialog.prototype.render = function () {
        var actions = [
            React.createElement(RaisedButton, { key: "create", className: "primary", primary: true, type: "submit", onClick: this.handleOkClikc, style: styles.action }, "OK"),
            React.createElement(FlatButton, { key: "close", onClick: this.handleCancel }, "M\u00E9gse")
        ];
        return (React.createElement(BoardyDialog, { open: true, title: "Munkaid\u0151 r\u00F6gz\u00EDt\u00E9s", onClosing: this.handleCancel, actions: actions },
            React.createElement("form", { onSubmit: this.handleSubmit, style: styles.form },
                React.createElement(TextField, { autoFocus: true, name: "hours", type: "number", step: 0.1, floatingLabelFixed: true, floatingLabelText: "Elt\u00F6lt\u00F6tt id\u0151 (\u00F3ra)", fullWidth: true, value: this.state.hours, onChange: this.handleHourChange }),
                React.createElement(TextField, { name: "note", multiLine: true, fullWidth: true, floatingLabelFixed: true, floatingLabelText: "Megjegyz\u00E9s", value: this.state.note, onChange: this.handleNoteChange }))));
    };
    return TaskTimeItemDialog;
}(React.Component));
export default TaskTimeItemDialog;



//////////////////
// WEBPACK FOOTER
// ./src/components/TaskTimeItemDialog.tsx
// module id = 770
// module chunks = 0